import {
  addMessage,
  addMessages
} from '../chat-body/index';

export const POST_MESSAGE = 'POST_MESSAGE';
export const POST_SUCCESS = 'POST_SUCCESS';
export const POST_FAILED = 'POST_FAILED';

export const postSuccess = () => ({
  type: POST_SUCCESS
});

export const postFailed = () => ({
  type: POST_FAILED
});

export const postMessage = params => (dispatch, getState) => {
  const {chatRoot} = getState();

  new Promise(chatRoot.protocol(params))
    .then(function(data) {
      dispatch(postSuccess());
      dispatch(addMessages(data));
    }, function() {
      dispatch(postFailed());
    });

  return dispatch({
    type: POST_MESSAGE
  });
};

export const sendMessage = params => (dispatch) => {
  dispatch(addMessage(params));
  dispatch(postMessage(params));
};



// WEBPACK FOOTER //
// ./src/actions/input-field/index.js